import styled from 'styled-components';

import {
    BACKGROUND_DEEP,
    BUTTON_CONTENT_BASE,
    CONTENT_BASE,
    TERTIARY_BORDER
} from '@amzn/ring-common-style-library/lib/colors';

import {
    BODY_SMALL_LIGHT,
    BODY_SMALL_MEDIUM,
} from '@amzn/ring-common-style-library/lib/typography';

const Divider = styled.hr`
    // account for FeedbackWrapper padding to extend edge to edge
    width: calc(100% + 32px);
    margin: 0 -16px;
    border: 1px solid ${TERTIARY_BORDER};
`;

const FeedbackCard = styled.div<{ header?: string }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;

    max-width: 300px;
    width: ${({ header }) => header ? '100%' : '102px'};
    padding: 8px 16px;
    gap: 8px;

    border-radius: 8px;
    border: 1px solid ${TERTIARY_BORDER};
    background: ${BUTTON_CONTENT_BASE};
`;

const FeedbackWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

const Header = styled.div`
    ${BODY_SMALL_MEDIUM};
    color: ${CONTENT_BASE};
`;

const Response = styled.div`
    ${BODY_SMALL_LIGHT};
    color: ${CONTENT_BASE};
    width: 100%;
`;

const ThumbsDownSelect = styled.div`
    width: 100%;
    button: {
        background-color: ${BACKGROUND_DEEP};
    }
`;

const ThumbsDownResponse = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    ${BODY_SMALL_LIGHT};
    color: ${CONTENT_BASE};
    width: 100%;
`;

const VoteWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`;

const VoteIcon = styled.div<{ disabled: boolean }>`
    display: flex;
    width: 32px;
    height: 32px;
    padding: 8px;
    justify-content: center;
    align-items: center;

    border-radius: 100px;
    border: 1px solid ${BACKGROUND_DEEP};
    background: ${BACKGROUND_DEEP};

    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

`;

export default {
    Divider,
    FeedbackCard,
    FeedbackWrapper,
    Header,
    Response,
    ThumbsDownSelect,
    ThumbsDownResponse,
    VoteWrapper,
    VoteIcon
}